import React, { Component } from 'react';
import { Spin, message } from 'antd';
import Title from '../Components/Title';
import Text from '../../../../basicElement/Text';
import compareFn from '../../Components/compareFn';
import TableC from '../../../../basicElement/TableC';
import EditableCell from '../../../../basicElement/EditableCell';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import format from '../../../../shared/format';

class CrcService extends Component {
    state = {
        data: [
            { name: '准备期', price: '32000', siteNo: '20', period: '3' },
            { name: '关中心', price: '32000', siteNo: '20', period: '3' },
            { name: '小计' },
        ],
        prevData: [],
        loading: false,
        canEdit: false,
    }

    componentDidMount() {
        const { editable } = this.props;
        this.setState({ canEdit: editable });
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.editable && this.props.editable) {
            this.setState({ canEdit: true });
        }
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.site.queryInvestigationSiteFee)
        .then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                pagination,
                data: datas,
                loading: false,
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({ loading: false });
        });
    }
    
    getColumns = () => {
        const { names, mode } = this.props;
        const { data, prevData, canEdit } = this.state;
        const len = data.length;
        const columns = [{
            title: '',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            render: (text, record, index) => {
                if (index < len - 1) {
                    return text;
                } else {
                    return <strong>{text}</strong>;
                }
            }
        }, {
            title: names.role,
            dataIndex: 'role',
            key: 'role',
            width: 100,
        }, {
            title: <span>{names.price}<br/>{names.cfm}</span>,
            dataIndex: 'price',
            key: 'price',
            width: 120,
            render: text => format('money', text),
        }, {
            title: <Text asterisk={canEdit}>{names.fte}</Text>,
            dataIndex: 'fte',
            key: 'fte',
            width: 120,
            render: (text, record, index) => {
                if (index !== len - 1) {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'fte');
                    } else {
                        return (
                            <div className="inlineBlock">
                                <EditableCell type="Number" editable={canEdit} value={text} config={{precision: 2}} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'fte')} />
                            </div>
                        );
                    }
                }
            }
        }, {
            title: names.siteNo,
            dataIndex: 'siteNo',
            key: 'siteNo',
            width: 80,
        }, {
            title: names.period,
            dataIndex: 'period',
            key: 'period',
            width: 100,
        }, {
            title: names.cost,
            dataIndex: 'cost',
            key: 'cost',
            width: 120,
            render: (text, record, index) => {
                if (index === len - 1) {
                    let total = 0;
                    data.forEach((item, index) => {
                        if (index < len - 1) {
                            total += (item.cost || 0) * 1;
                        }
                    });
                    return format('money', total);
                } else {
                    return <strong>{format('money', text)}</strong>;
                }
            }
        }, {
            title: names.otherRemarks,
            dataIndex: 'otherRemarks',
            key: 'otherRemarks',
            render: (text, record, index) => {
                if (mode === 'compare') {
                    return compareFn(prevData, data, 'otherRemarks');
                } else {
                    return (
                        <div className="inlineBlock">
                            <EditableCell type="Input" editable={canEdit} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'otherRemarks')} />
                        </div>
                    );
                }
            }
        }];
        return columns;
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        const target = data[index];
        target[key] = value;
        if (key === 'fte') {
            const { price, siteNo, period, fte } = target;
            target.cost = price * (fte || 0) * siteNo * period;
        }
        // this.props.hasChange(true);
        this.setState({ data: [...data] });
    }

    save = (canEdit) => {
        if (!canEdit) {
            this.setState({ canEdit: true });
        } else {
            const { names } = this.props;
            const { data } = this.state;
            for (let i = 0; i < data.length - 1; i++) {
                const item = data[i];
                if (!item.fte && item.fte !== 0) {
                    message.warning(`${names.inputPlaceholder}${names.fte}!`);
                    return;
                }
            }
            this.setState({ canEdit: false });
            // this.props.hasChange(false);
        }
    }

    render() {
        const { title, editable } = this.props;
        const { data, loading, canEdit } = this.state;
        return (
            <Spin spinning={loading}>
                <Title title={title} editable={editable} canEdit={canEdit} save={this.save} />
                <div style={{ paddingLeft: 10 }}>
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                        className="quotation_crcService"
                    />
                </div>
            </Spin>
        );
    }
}

export default CrcService;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/Table/CrcService.js